import { atom } from 'jotai';
import { uploadAbortControllerAtom } from '../../upcoming-session-tab/atoms';

/**
 * Action to create a new upload AbortController.
 * Returns the created controller.
 */
export const newUploadAbortControllerAction = atom(null, (_, set): AbortController => {
  const abortController = new AbortController();
  set(uploadAbortControllerAtom, abortController);
  return abortController;
});

/**
 * Action to clear the upload AbortController.
 */
export const clearUploadAbortControllerAction = atom(null, (_, set) => {
  set(uploadAbortControllerAtom, null);
});

/**
 * Action to abort the current upload and clear the controller.
 */
export const abortUploadAction = atom(null, (_, set) => {
  set(uploadAbortControllerAtom, (prev) => {
    if (prev) {
      prev.abort();
      return null;
    }
    return prev;
  });
});
